'use client'
import { createContext, Dispatch, SetStateAction } from 'react'
import { SailPackage } from '@/root/shared-types'

export type SailPackageContextType = {
  setSailPackage: Dispatch<SetStateAction<SailPackage | undefined>>
  sailPackage?: SailPackage
}

export const SailPackageContext = createContext<SailPackageContextType | null>(null)
